const brandTheme = {
    mainColor:'#d3d3d3',
    errorColor:'#f44336',
    buttonColor: '#2f2f2fc9',
    buttonHoverColor:'#2f2f2f',
    white:'#ffffff',
    black: '#2f2f2f',
    fieldColor: '#7c7171',
    footerBackGroundColor:'#d3d3d33b',
    headerBackGroundColor:'#d3d3d33b',
    sideBarColor: '#d3d3d33b',
    sideBarHoverColor: "#d3d3d3",
    headerFontSize: "1.65rem",
    innerHeaderFontSize: "1rem",
    button2Color: "#848181",
    disabled:"#e5e5e5",
    red:"#DD262B",
    grey:"#999999",
    lightBlue:"#1AA2DF",
    tableHeaderColor:"#fafafa",
    tableHoverColor:"#0000000a",
    font: {
        roboto: 'Roboto',
        poppins: 'Poppins',
        // hindFontSemiBold: 'Hind-SemiBold',
        // hindFontRegular: 'Hind-Regular',
        // hindFontMedium: 'Hind-Medium',
        // hindFontLight: 'Hind-Light',
        // bebaseNeueRegular: 'BebasNeue-Regular'
    },
    
};

export default brandTheme;
